// source: pbtypes/infrastructure/flight_connect/link_summary.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_tools_cloud_api_enums_pb = require('../../../pbtypes/tools/cloud_api/enums_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_enums_pb);
var pbtypes_gen_telit_lte_modem_deployment_mode_pb = require('../../../pbtypes/gen/telit_lte_modem/deployment_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_deployment_mode_pb);
var pbtypes_gen_streaming_bitrate_controller_link_type_pb = require('../../../pbtypes/gen/streaming_bitrate_controller/link_type_pb.js');
goog.object.extend(proto, pbtypes_gen_streaming_bitrate_controller_link_type_pb);
var pbtypes_gen_vehicle_attributes_device_type_pb = require('../../../pbtypes/gen/vehicle_attributes/device_type_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_attributes_device_type_pb);
var pbtypes_gen_wifi_service_wireless_channel_band_list_pb = require('../../../pbtypes/gen/wifi_service/wireless_channel_band_list_pb.js');
goog.object.extend(proto, pbtypes_gen_wifi_service_wireless_channel_band_list_pb);
goog.exportSymbol('proto.flight_connect.DeviceConnectionQuality', null, global);
goog.exportSymbol('proto.flight_connect.DeviceConnectionQuality.Enum', null, global);
goog.exportSymbol('proto.flight_connect.DeviceLinkSummary', null, global);
goog.exportSymbol('proto.flight_connect.DeviceLinkSummary.KindCase', null, global);
goog.exportSymbol('proto.flight_connect.DeviceLinkSummary.LTESummary', null, global);
goog.exportSymbol('proto.flight_connect.DeviceLinkSummary.WifiSummary', null, global);
goog.exportSymbol('proto.flight_connect.DeviceLinksSummary', null, global);
goog.exportSymbol('proto.flight_connect.VideoStreamSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceConnectionQuality = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.DeviceConnectionQuality, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceConnectionQuality.displayName = 'proto.flight_connect.DeviceConnectionQuality';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceLinkSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_connect.DeviceLinkSummary.repeatedFields_, proto.flight_connect.DeviceLinkSummary.oneofGroups_);
};
goog.inherits(proto.flight_connect.DeviceLinkSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceLinkSummary.displayName = 'proto.flight_connect.DeviceLinkSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceLinkSummary.LTESummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.DeviceLinkSummary.LTESummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceLinkSummary.LTESummary.displayName = 'proto.flight_connect.DeviceLinkSummary.LTESummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.DeviceLinkSummary.WifiSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceLinkSummary.WifiSummary.displayName = 'proto.flight_connect.DeviceLinkSummary.WifiSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.VideoStreamSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.VideoStreamSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.VideoStreamSummary.displayName = 'proto.flight_connect.VideoStreamSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceLinksSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_connect.DeviceLinksSummary.repeatedFields_, null);
};
goog.inherits(proto.flight_connect.DeviceLinksSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceLinksSummary.displayName = 'proto.flight_connect.DeviceLinksSummary';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceConnectionQuality.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceConnectionQuality.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceConnectionQuality} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceConnectionQuality.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceConnectionQuality}
 */
proto.flight_connect.DeviceConnectionQuality.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceConnectionQuality;
  return proto.flight_connect.DeviceConnectionQuality.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceConnectionQuality} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceConnectionQuality}
 */
proto.flight_connect.DeviceConnectionQuality.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceConnectionQuality.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceConnectionQuality.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceConnectionQuality} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceConnectionQuality.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.flight_connect.DeviceConnectionQuality.Enum = {
  UNKNOWN: 0,
  POOR: 1,
  FAIR: 2,
  GOOD: 3
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_connect.DeviceLinkSummary.repeatedFields_ = [3];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.flight_connect.DeviceLinkSummary.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.flight_connect.DeviceLinkSummary.KindCase = {
  KIND_NOT_SET: 0,
  LTE_SUMMARY: 4,
  WIFI_SUMMARY: 5
};

/**
 * @return {proto.flight_connect.DeviceLinkSummary.KindCase}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getKindCase = function() {
  return /** @type {proto.flight_connect.DeviceLinkSummary.KindCase} */(jspb.Message.computeOneofCase(this, proto.flight_connect.DeviceLinkSummary.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceLinkSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceLinkSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceLinkSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinkSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
bitrate: jspb.Message.getFieldWithDefault(msg, 2, 0),
selectedStreamsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
quality: jspb.Message.getFieldWithDefault(msg, 6, 0),
lteSummary: (f = msg.getLteSummary()) && proto.flight_connect.DeviceLinkSummary.LTESummary.toObject(includeInstance, f),
wifiSummary: (f = msg.getWifiSummary()) && proto.flight_connect.DeviceLinkSummary.WifiSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceLinkSummary}
 */
proto.flight_connect.DeviceLinkSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceLinkSummary;
  return proto.flight_connect.DeviceLinkSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceLinkSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceLinkSummary}
 */
proto.flight_connect.DeviceLinkSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBitrate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedStreams(value);
      break;
    case 6:
      var value = /** @type {!proto.flight_connect.DeviceConnectionQuality.Enum} */ (reader.readEnum());
      msg.setQuality(value);
      break;
    case 4:
      var value = new proto.flight_connect.DeviceLinkSummary.LTESummary;
      reader.readMessage(value,proto.flight_connect.DeviceLinkSummary.LTESummary.deserializeBinaryFromReader);
      msg.setLteSummary(value);
      break;
    case 5:
      var value = new proto.flight_connect.DeviceLinkSummary.WifiSummary;
      reader.readMessage(value,proto.flight_connect.DeviceLinkSummary.WifiSummary.deserializeBinaryFromReader);
      msg.setWifiSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceLinkSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceLinkSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceLinkSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinkSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBitrate();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getSelectedStreamsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getLteSummary();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.flight_connect.DeviceLinkSummary.LTESummary.serializeBinaryToWriter
    );
  }
  f = message.getWifiSummary();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.flight_connect.DeviceLinkSummary.WifiSummary.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceLinkSummary.LTESummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceLinkSummary.LTESummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.toObject = function(includeInstance, msg) {
  var f, obj = {
iccid: jspb.Message.getFieldWithDefault(msg, 8, ""),
carrier: jspb.Message.getFieldWithDefault(msg, 2, ""),
sourceLink: jspb.Message.getFieldWithDefault(msg, 9, 0),
rsrpDbm: jspb.Message.getFieldWithDefault(msg, 3, 0),
rsrqDb: jspb.Message.getFieldWithDefault(msg, 4, 0),
currentBand: jspb.Message.getFieldWithDefault(msg, 5, 0),
bandwidthMhz: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
bwMhz: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
deploymentMode: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceLinkSummary.LTESummary;
  return proto.flight_connect.DeviceLinkSummary.LTESummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceLinkSummary.LTESummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCarrier(value);
      break;
    case 9:
      var value = /** @type {!proto.streaming_bitrate_controller.LinkType.Enum} */ (reader.readEnum());
      msg.setSourceLink(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRsrpDbm(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRsrqDb(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentBand(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBandwidthMhz(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBwMhz(value);
      break;
    case 7:
      var value = /** @type {!proto.telit_lte_modem.DeploymentMode.Enum} */ (reader.readEnum());
      msg.setDeploymentMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceLinkSummary.LTESummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceLinkSummary.LTESummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCarrier();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSourceLink();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getRsrpDbm();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRsrqDb();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCurrentBand();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getBandwidthMhz();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getBwMhz();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getDeploymentMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string iccid = 8;
 * @return {string}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getIccid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setIccid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string carrier = 2;
 * @return {string}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getCarrier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setCarrier = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional streaming_bitrate_controller.LinkType.Enum source_link = 9;
 * @return {!proto.streaming_bitrate_controller.LinkType.Enum}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getSourceLink = function() {
  return /** @type {!proto.streaming_bitrate_controller.LinkType.Enum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.streaming_bitrate_controller.LinkType.Enum} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setSourceLink = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional int32 rsrp_dbm = 3;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getRsrpDbm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setRsrpDbm = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 rsrq_db = 4;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getRsrqDb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setRsrqDb = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 current_band = 5;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getCurrentBand = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setCurrentBand = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional float bandwidth_mhz = 6;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getBandwidthMhz = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setBandwidthMhz = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float bw_mhz = 10;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getBwMhz = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setBwMhz = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional telit_lte_modem.DeploymentMode.Enum deployment_mode = 7;
 * @return {!proto.telit_lte_modem.DeploymentMode.Enum}
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.getDeploymentMode = function() {
  return /** @type {!proto.telit_lte_modem.DeploymentMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.telit_lte_modem.DeploymentMode.Enum} value
 * @return {!proto.flight_connect.DeviceLinkSummary.LTESummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.LTESummary.prototype.setDeploymentMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceLinkSummary.WifiSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceLinkSummary.WifiSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
primaryPeerSerial: jspb.Message.getFieldWithDefault(msg, 1, ""),
primaryPeerDeviceType: jspb.Message.getFieldWithDefault(msg, 2, 0),
ssid: jspb.Message.getFieldWithDefault(msg, 3, ""),
bssid: jspb.Message.getFieldWithDefault(msg, 4, ""),
idleTime: jspb.Message.getFieldWithDefault(msg, 5, 0),
channel: jspb.Message.getFieldWithDefault(msg, 6, 0),
channelBand: jspb.Message.getFieldWithDefault(msg, 8, 0),
rssi: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceLinkSummary.WifiSummary;
  return proto.flight_connect.DeviceLinkSummary.WifiSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceLinkSummary.WifiSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryPeerSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.vehicle_attributes.DeviceType.Enum} */ (reader.readEnum());
      msg.setPrimaryPeerDeviceType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSsid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBssid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIdleTime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChannel(value);
      break;
    case 8:
      var value = /** @type {!proto.wifi_service.WirelessChannelBandList.Enum} */ (reader.readEnum());
      msg.setChannelBand(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRssi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceLinkSummary.WifiSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceLinkSummary.WifiSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryPeerSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrimaryPeerDeviceType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSsid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBssid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIdleTime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getChannel();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getChannelBand();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getRssi();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string primary_peer_serial = 1;
 * @return {string}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getPrimaryPeerSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setPrimaryPeerSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional vehicle_attributes.DeviceType.Enum primary_peer_device_type = 2;
 * @return {!proto.vehicle_attributes.DeviceType.Enum}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getPrimaryPeerDeviceType = function() {
  return /** @type {!proto.vehicle_attributes.DeviceType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.vehicle_attributes.DeviceType.Enum} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setPrimaryPeerDeviceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string ssid = 3;
 * @return {string}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getSsid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setSsid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string bssid = 4;
 * @return {string}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getBssid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setBssid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 idle_time = 5;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getIdleTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setIdleTime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 channel = 6;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getChannel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setChannel = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional wifi_service.WirelessChannelBandList.Enum channel_band = 8;
 * @return {!proto.wifi_service.WirelessChannelBandList.Enum}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getChannelBand = function() {
  return /** @type {!proto.wifi_service.WirelessChannelBandList.Enum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.wifi_service.WirelessChannelBandList.Enum} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setChannelBand = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional int32 rssi = 7;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.getRssi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary.WifiSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.WifiSummary.prototype.setRssi = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional uint64 bitrate = 2;
 * @return {number}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.setBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string selected_streams = 3;
 * @return {!Array<string>}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getSelectedStreamsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.setSelectedStreamsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.addSelectedStreams = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.clearSelectedStreamsList = function() {
  return this.setSelectedStreamsList([]);
};


/**
 * optional DeviceConnectionQuality.Enum quality = 6;
 * @return {!proto.flight_connect.DeviceConnectionQuality.Enum}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getQuality = function() {
  return /** @type {!proto.flight_connect.DeviceConnectionQuality.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.flight_connect.DeviceConnectionQuality.Enum} value
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.setQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional LTESummary lte_summary = 4;
 * @return {?proto.flight_connect.DeviceLinkSummary.LTESummary}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getLteSummary = function() {
  return /** @type{?proto.flight_connect.DeviceLinkSummary.LTESummary} */ (
    jspb.Message.getWrapperField(this, proto.flight_connect.DeviceLinkSummary.LTESummary, 4));
};


/**
 * @param {?proto.flight_connect.DeviceLinkSummary.LTESummary|undefined} value
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
*/
proto.flight_connect.DeviceLinkSummary.prototype.setLteSummary = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.flight_connect.DeviceLinkSummary.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.clearLteSummary = function() {
  return this.setLteSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_connect.DeviceLinkSummary.prototype.hasLteSummary = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional WifiSummary wifi_summary = 5;
 * @return {?proto.flight_connect.DeviceLinkSummary.WifiSummary}
 */
proto.flight_connect.DeviceLinkSummary.prototype.getWifiSummary = function() {
  return /** @type{?proto.flight_connect.DeviceLinkSummary.WifiSummary} */ (
    jspb.Message.getWrapperField(this, proto.flight_connect.DeviceLinkSummary.WifiSummary, 5));
};


/**
 * @param {?proto.flight_connect.DeviceLinkSummary.WifiSummary|undefined} value
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
*/
proto.flight_connect.DeviceLinkSummary.prototype.setWifiSummary = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.flight_connect.DeviceLinkSummary.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_connect.DeviceLinkSummary} returns this
 */
proto.flight_connect.DeviceLinkSummary.prototype.clearWifiSummary = function() {
  return this.setWifiSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_connect.DeviceLinkSummary.prototype.hasWifiSummary = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.VideoStreamSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.VideoStreamSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.VideoStreamSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.VideoStreamSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
channel: jspb.Message.getFieldWithDefault(msg, 1, ""),
fusedFramerate: jspb.Message.getFieldWithDefault(msg, 2, 0),
fusedBitrate: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.VideoStreamSummary}
 */
proto.flight_connect.VideoStreamSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.VideoStreamSummary;
  return proto.flight_connect.VideoStreamSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.VideoStreamSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.VideoStreamSummary}
 */
proto.flight_connect.VideoStreamSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFusedFramerate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFusedBitrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.VideoStreamSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.VideoStreamSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.VideoStreamSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.VideoStreamSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFusedFramerate();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getFusedBitrate();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional string channel = 1;
 * @return {string}
 */
proto.flight_connect.VideoStreamSummary.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.VideoStreamSummary} returns this
 */
proto.flight_connect.VideoStreamSummary.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 fused_framerate = 2;
 * @return {number}
 */
proto.flight_connect.VideoStreamSummary.prototype.getFusedFramerate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoStreamSummary} returns this
 */
proto.flight_connect.VideoStreamSummary.prototype.setFusedFramerate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 fused_bitrate = 3;
 * @return {number}
 */
proto.flight_connect.VideoStreamSummary.prototype.getFusedBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoStreamSummary} returns this
 */
proto.flight_connect.VideoStreamSummary.prototype.setFusedBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_connect.DeviceLinksSummary.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceLinksSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceLinksSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceLinksSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinksSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
summarizationUtime: jspb.Message.getFieldWithDefault(msg, 1, 0),
serial: jspb.Message.getFieldWithDefault(msg, 2, ""),
deviceType: jspb.Message.getFieldWithDefault(msg, 3, ""),
rttMs: jspb.Message.getFieldWithDefault(msg, 4, 0),
videoStreamSummariesList: jspb.Message.toObjectList(msg.getVideoStreamSummariesList(),
    proto.flight_connect.VideoStreamSummary.toObject, includeInstance),
linkSummariesList: jspb.Message.toObjectList(msg.getLinkSummariesList(),
    proto.flight_connect.DeviceLinkSummary.toObject, includeInstance),
overallQuality: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceLinksSummary}
 */
proto.flight_connect.DeviceLinksSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceLinksSummary;
  return proto.flight_connect.DeviceLinksSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceLinksSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceLinksSummary}
 */
proto.flight_connect.DeviceLinksSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSummarizationUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRttMs(value);
      break;
    case 5:
      var value = new proto.flight_connect.VideoStreamSummary;
      reader.readMessage(value,proto.flight_connect.VideoStreamSummary.deserializeBinaryFromReader);
      msg.addVideoStreamSummaries(value);
      break;
    case 6:
      var value = new proto.flight_connect.DeviceLinkSummary;
      reader.readMessage(value,proto.flight_connect.DeviceLinkSummary.deserializeBinaryFromReader);
      msg.addLinkSummaries(value);
      break;
    case 7:
      var value = /** @type {!proto.flight_connect.DeviceConnectionQuality.Enum} */ (reader.readEnum());
      msg.setOverallQuality(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceLinksSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceLinksSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceLinksSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceLinksSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummarizationUtime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeviceType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRttMs();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getVideoStreamSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.flight_connect.VideoStreamSummary.serializeBinaryToWriter
    );
  }
  f = message.getLinkSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.flight_connect.DeviceLinkSummary.serializeBinaryToWriter
    );
  }
  f = message.getOverallQuality();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional uint64 summarization_utime = 1;
 * @return {number}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getSummarizationUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.setSummarizationUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string serial = 2;
 * @return {string}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string device_type = 3;
 * @return {string}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getDeviceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.setDeviceType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 rtt_ms = 4;
 * @return {number}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.setRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated VideoStreamSummary video_stream_summaries = 5;
 * @return {!Array<!proto.flight_connect.VideoStreamSummary>}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getVideoStreamSummariesList = function() {
  return /** @type{!Array<!proto.flight_connect.VideoStreamSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_connect.VideoStreamSummary, 5));
};


/**
 * @param {!Array<!proto.flight_connect.VideoStreamSummary>} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
*/
proto.flight_connect.DeviceLinksSummary.prototype.setVideoStreamSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.flight_connect.VideoStreamSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.VideoStreamSummary}
 */
proto.flight_connect.DeviceLinksSummary.prototype.addVideoStreamSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.flight_connect.VideoStreamSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.clearVideoStreamSummariesList = function() {
  return this.setVideoStreamSummariesList([]);
};


/**
 * repeated DeviceLinkSummary link_summaries = 6;
 * @return {!Array<!proto.flight_connect.DeviceLinkSummary>}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getLinkSummariesList = function() {
  return /** @type{!Array<!proto.flight_connect.DeviceLinkSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flight_connect.DeviceLinkSummary, 6));
};


/**
 * @param {!Array<!proto.flight_connect.DeviceLinkSummary>} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
*/
proto.flight_connect.DeviceLinksSummary.prototype.setLinkSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.flight_connect.DeviceLinkSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.DeviceLinkSummary}
 */
proto.flight_connect.DeviceLinksSummary.prototype.addLinkSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.flight_connect.DeviceLinkSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.clearLinkSummariesList = function() {
  return this.setLinkSummariesList([]);
};


/**
 * optional DeviceConnectionQuality.Enum overall_quality = 7;
 * @return {!proto.flight_connect.DeviceConnectionQuality.Enum}
 */
proto.flight_connect.DeviceLinksSummary.prototype.getOverallQuality = function() {
  return /** @type {!proto.flight_connect.DeviceConnectionQuality.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.flight_connect.DeviceConnectionQuality.Enum} value
 * @return {!proto.flight_connect.DeviceLinksSummary} returns this
 */
proto.flight_connect.DeviceLinksSummary.prototype.setOverallQuality = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


goog.object.extend(exports, proto.flight_connect);
